import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';

import failureWatcher from './watchers/failureWatcher';
import actionPromisifyWatcher from './watchers/promisifyWatcher';
import { rootReducer, rootSagas } from './ducks';

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
  const logger = createLogger({ collapsed: true });
  middlewares.push(logger);
}

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middlewares)),
);
const persistor = persistStore(store);
const sagas = [rootSagas, actionPromisifyWatcher, failureWatcher];

sagas.forEach(saga => sagaMiddleware.run(saga));

export { persistor, store };
